import { Checkbox } from "UI/UI.BaseControls/Checkbox";
import { ToolbarGroup } from "../UI/Toolbar/ToolbarGroup";
import { ToolbarGroups } from "../UI/Toolbar/ToolbarGroups";
import { MSLOV } from "../UI/XGControls/MSLOV";
import { ComponentTree } from "./ComponentTree";
import { ComponentTreeType } from "./Definitions";
import { ILogicalComponent } from "./ILogicalComponent";
/**
 * Dynamický uzel stromu. Kromě stromu komponent akcí a potomků nalezeném při sestavení stromu,
 * vrací při každém průchodu také dynamický podstrom, který obsahuje nalezené komponenty a standardní řádkové akce
 */
export class MSLOVComponentTree extends ComponentTree {
    //#region Protected members
    protected static override _excludedComponentTypes: Function[] = [ToolbarGroups, ToolbarGroup, Checkbox];
    //#endregion

    //#region Private members

    //#endregion Private members

    //#region Public members

    //#endregion Public members;

    constructor(component: ILogicalComponent, parentNode: ComponentTreeType) {
        super(component, parentNode);
    }

    //#region Private methods

    //#endregion Private methods

    //#region Public methods

    /** Tovární funkce vytvářející speciální uzly stromu    */
    public static createNodeFactory(controlWrapper: ILogicalComponent, parentNode: ComponentTreeType): ComponentTree | undefined {
        if (controlWrapper.control instanceof MSLOV)
            return new MSLOVComponentTree(controlWrapper, parentNode);
        else
            return undefined;
    }

    //#endregion Public methods
}
